import { toast } from 'react-hot-toast'

/** What the API's CSV upload endpoints return (DeltaTableService.upsert_csv). */
export type UploadResult = {
  message?: string
  rowsInFile?: number
  rowsUpdated?: number
  duplicateKeysDropped?: number
  ignoredColumns?: string[]
}

/**
 * Say what an upload changed. A file whose keys match nothing still
 * "succeeds", so the count is the only sign that it did nothing.
 */
export const toastUploadResult = (result?: UploadResult) => {
  if (result?.rowsUpdated === undefined) {
    toast.success('Upload complete')
    return
  }
  const { rowsUpdated, rowsInFile } = result
  if (rowsUpdated === 0) {
    toast.error(
      `No rows matched. Check the file has this table's key columns and values (${rowsInFile ?? 0} rows read).`
    )
    return
  }
  toast.success(
    `Upload complete: ${rowsUpdated} rows updated from ${rowsInFile} in the file`
  )
}

/** Show the API's reason, e.g. a missing key column or clashing duplicate rows. */
export const toastUploadError = (error?: unknown) => {
  const reason = (error as { response?: { data?: { error?: string } } })
    ?.response?.data?.error
  toast.error(reason ? `Upload failed: ${reason}` : 'Upload failed')
}
